/*
 *
 * ManageCreditCard constants
 *
 */

export const DEFAULT_ACTION = 'app/ManageCreditCard/DEFAULT_ACTION';
